import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import GroupLeaderSearch from 'components/ui/GroupLeaderSearch';
import Input from '../../../components/ui/Input';
import { isMemberBlocked } from 'utils/member-utils';

const GroupLeaderModal = ({ isModalOpen, setIsModalOpen, selectedPoint, getGroupLeaderDeatils, existingGroupLeaders = [] }) => {
    const [sectorOptions, setSectorOptions] = useState([]);
    console.log("edit gl", selectedPoint)
    // Leader dropdown options
    const [leader1Options, setLeader1Options] = useState([]);
    const [leader2Options, setLeader2Options] = useState([]);
    const [batchDeatils, setBatchDetails] = useState('')

    const [formData, setFormData] = useState({
        batch: '',
        sector: '',
        leader1: '',
        leader2: '',
    });

    const [saiConnectedId1, setSaiConnectedId1] = useState('')
    const [saiConnectedId2, setSaiConnectedId2] = useState('')
    const [editId, setEditId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showAddAnotherPrompt, setShowAddAnotherPrompt] = useState(false);
    const [assignedLeaderIds, setAssignedLeaderIds] = useState([]);
    const [assignedSectorIds, setAssignedSectorIds] = useState([]);

    // Fetch sector values
    useEffect(() => {
        getSectorValue();
        getCurrentBatch()
    }, []);



    const getCurrentBatch = async () => {
        try {
            const data = await httpHelper(
                URL_CONSTANTS.GET_CURRENT_BATCH_DETAILS,
                Method_TYPE.GET
            );
            const batchId = data?._id || '';
            setBatchDetails(batchId);
            setFormData(prev => ({
                ...prev,
                batch: batchId
            }));

        } catch (err) {
            console.error("Error fetching batch details:", err);
            setBatchDetails('')
        }
    };
    const getSectorValue = async () => {
        try {
            const data = await httpHelper(URL_CONSTANTS.GET_SECOTR_VALUES, Method_TYPE.GET);
            setSectorOptions(
                data?.data?.map((sector) => ({
                    value: sector?._id,
                    label: sector?.name,
                })) || []
            );
        } catch (err) {
            console.error('Error fetching sector values:', err);
            setSectorOptions([]);
        }
    };

    const getAssignedIds = (rows = [], excludeId) => {
        const leaderIds = new Set();
        const sectorIds = new Set();
        rows.forEach((row) => {
            if (excludeId && row.id === excludeId) return;
            if (row?.leader1?.leader1Id) leaderIds.add(row.leader1.leader1Id);
            if (row?.leader2?.leader2Id) leaderIds.add(row.leader2.leader2Id);
            if (row?.sector?.sectorId) sectorIds.add(row.sector.sectorId);
        });
        return {
            leaderIds: Array.from(leaderIds),
            sectorIds: Array.from(sectorIds),
        };
    };

    useEffect(() => {
        if (!isModalOpen) {
            setAssignedLeaderIds([]);
            setAssignedSectorIds([]);
            return;
        }
        const excludeId = selectedPoint?.[0]?.id;
        const fromExisting = getAssignedIds(existingGroupLeaders, excludeId);
        setAssignedLeaderIds((prev) => [...new Set([...prev, ...fromExisting.leaderIds])]);
        setAssignedSectorIds((prev) => [...new Set([...prev, ...fromExisting.sectorIds])]);
    }, [isModalOpen, existingGroupLeaders, selectedPoint]);

    // Populate form for edit
    useEffect(() => {
        if (selectedPoint?.length > 0) {
            const sp = selectedPoint[0];

            setFormData({
                batch: sp.batch?.batchId || '',
                sector: sp.sector?.sectorId || '',
                leader1: sp.leader1?.leader1Id || '',
                leader2: sp.leader2?.leader2Id || ''
            });
            getSaiConnectedId('leader1',sp.leader1?.leader1Id)
            getSaiConnectedId('leader2',sp.leader2?.leader2Id)
            // Ensure dropdown options contain the selected leaders
            setLeader1Options([{
                _id: sp.leader1?.leader1Id,
                name: sp.leader1?.leader1Name
            }]);
            setLeader2Options([{
                _id: sp.leader2?.leader2Id,
                name: sp.leader2?.leader2Name
            }]);

            setEditId(sp.id);
        }
    }, [selectedPoint]);

    const clearFormFields = (keepBatch = true) => {
        setLeader1Options([]);
        setLeader2Options([]);
        setSaiConnectedId1('');
        setSaiConnectedId2('');
        setEditId('');
        setFormData({
            batch: keepBatch ? (batchDeatils || '') : '',
            sector: '',
            leader1: '',
            leader2: '',
        });
    };

    const handleCancel = () => {
        setShowAddAnotherPrompt(false);
        setAssignedLeaderIds([]);
        setAssignedSectorIds([]);
        setIsModalOpen(false);
        clearFormFields(false);
    };

    const handleAddAnotherYes = () => {
        setShowAddAnotherPrompt(false);
        clearFormFields(true);
        if (!batchDeatils) {
            getCurrentBatch();
        }
    };

    const handleAddAnotherNo = () => {
        handleCancel();
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const groupLeadObj = { ...formData };

            if(groupLeadObj.leader2 === '' || !groupLeadObj.leader2){
                delete groupLeadObj.leader2

            }   
            
            const isEdit = selectedPoint?.length > 0;

            if (isEdit) {
                await httpHelper(`${URL_CONSTANTS.GROUP_LEADER}`, Method_TYPE.PUT, groupLeadObj);
                getGroupLeaderDeatils();
                handleCancel();
            } else {
                await httpHelper(URL_CONSTANTS.GROUP_LEADER, Method_TYPE.POST, groupLeadObj);
                getGroupLeaderDeatils();
                const newlyAssignedIds = [formData.leader1, formData.leader2].filter(Boolean);
                setAssignedLeaderIds((prev) => [...new Set([...prev, ...newlyAssignedIds])]);
                if (formData.sector) {
                    setAssignedSectorIds((prev) => [...new Set([...prev, formData.sector])]);
                }
                setShowAddAnotherPrompt(true);
            }
        } catch (error) {
            console.error('Error saving Group Leader:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const getSaiConnectedId = (type,value) => {
        console.log("saiid",type,value)

        if(type === 'leader1'){
        const selectedMember = leader1Options.find(m => m._id === value);
       // console.log("sai if id",{selectedMember,leader1Optio})
        setSaiConnectedId1(selectedMember?.saiOneId || '');
        }else{
            const selectedMember = leader2Options.find(m => m._id === value);
            console.log("saielse id",selectedMember)
        setSaiConnectedId2(selectedMember?.saiOneId || '');
        }    
    
    }



    if (!isModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-card rounded-lg border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="flex items-center justify-between p-6 border-b border-border">
                    <div>
                        <h2 className="font-heading font-semibold text-lg text-foreground">
                            {selectedPoint?.length > 0 ? 'Edit Group Leader' : 'Add Group Leader'}
                        </h2>
                        <p className="text-sm text-muted-foreground">
                            Configure Group Leader requirements and details
                        </p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={handleCancel} iconName="X" />
                </div>

                {showAddAnotherPrompt ? (
                    <div className="p-8 text-center space-y-6">
                        <div className="mx-auto w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
                            <span className="text-success text-xl font-semibold">✓</span>
                        </div>
                        <div>
                            <h3 className="font-heading font-semibold text-lg text-foreground mb-2">
                                Group Leader added successfully
                            </h3>
                            <p className="text-sm text-muted-foreground">
                                Would you like to add group leader for one more sector?
                            </p>
                        </div>
                        <div className="flex items-center justify-center gap-3">
                            <Button type="button" variant="outline" onClick={handleAddAnotherNo}>
                                No
                            </Button>
                            <Button type="button" variant="default" onClick={handleAddAnotherYes}>
                                Yes
                            </Button>
                        </div>
                    </div>
                ) : (
                <form onSubmit={handleSubmit} className="p-6 space-y-6">
                    <div className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Select
                                label="Sector"
                                options={sectorOptions.map((option) => ({
                                    ...option,
                                    disabled: assignedSectorIds.includes(option.value),
                                }))}
                                name="sector"
                                value={formData.sector}
                                onChange={(value) => handleInputChange('sector', value)}
                                required
                            />
                        </div>
                        <GroupLeaderSearch setSearchResults={setLeader1Options} saiConnectedId1={saiConnectedId1} setSaiConnectedId1={setSaiConnectedId1} />

                        {/* Leader 1 */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Select
                                label="Leader 1"
                                options={leader1Options.map(member => ({
                                    value: member._id,
                                    label: member.name + (isMemberBlocked(member) ? ' (Blocked)' : ''),
                                    disabled: assignedLeaderIds.includes(member._id) || member._id === formData.leader2 || isMemberBlocked(member)
                                }))}
                                name="leader1"
                                value={formData.leader1}
                                onChange={(value) => {
                                    handleInputChange('leader1', value);
                                    // Find SaiOne ID from options list
                                   getSaiConnectedId('leader1',value)
                                }}
                                required
                            />
                            <Input
                                label="Sai Connected Id1"
                                name="saiConnectedId1"
                                value={saiConnectedId1?saiConnectedId1:'---'}
                                
                            />
                            
                        </div>
                        <GroupLeaderSearch setSearchResults={setLeader2Options} saiConnectedId2={saiConnectedId2} setSaiConnectedId2={setSaiConnectedId2} />
                        {/* Leader 2 */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Select
                                label="Leader 2"
                                options={leader2Options.map(member => ({
                                    value: member._id,
                                    label: member.name + (isMemberBlocked(member) ? ' (Blocked)' : ''),
                                    disabled: assignedLeaderIds.includes(member._id) || member._id === formData.leader1 || isMemberBlocked(member)
                                }))}
                                name="leader2"
                                value={formData.leader2}
                                onChange={(value) => {
                                    handleInputChange('leader2', value);

                                    getSaiConnectedId('leader2',value)
                                }}
                                /*required*/
                            />
                            <Input
                                label="Sai Connected Id2"
                                name="saiConnectedId2"
                                value={saiConnectedId2?saiConnectedId2:'---'}
                               
                            />
                            
                        </div>
                    </div>

                    <div className="flex items-center justify-end space-x-3 pt-4 border-t border-border">
                        <Button type="button" variant="outline" onClick={handleCancel} disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="default"
                            loading={isLoading}
                            iconName="Save"
                            iconPosition="left"
                        >
                            {selectedPoint?.length > 0 ? 'Update Group Leader' : 'Create Group Leader'}
                        </Button>
                    </div>
                </form>
                )}
            </div>
        </div>
    );
};

export default GroupLeaderModal;
